const LEGACY_ANOMALY_DESCRIPTION_PATTERN =
  /^Erreur de tri détectée sur le conteneur (.+?)\.?$/i;

export const formatAnomalyNotificationDescription = (description) => {
  if (!description) {
    return description;
  }

  const legacyMatch = description.match(LEGACY_ANOMALY_DESCRIPTION_PATTERN);
  if (!legacyMatch) {
    return description;
  }

  const siteLabel = legacyMatch[1].trim();
  const formattedSite = siteLabel.charAt(0).toUpperCase() + siteLabel.slice(1);

  return `Erreur détectée - ${formattedSite}`;
};
